import { render, staticRenderFns } from "./doctorMarket.vue?vue&type=template&id=a85865f2&scoped=true&"
import script from "./doctorMarket.vue?vue&type=script&lang=js&"
export * from "./doctorMarket.vue?vue&type=script&lang=js&"
import style0 from "./doctorMarket.vue?vue&type=style&index=0&lang=css&"
import style1 from "./doctorMarket.vue?vue&type=style&index=1&id=a85865f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85865f2",
  null
  
)

export default component.exports